export default __webpack_public_path__ + "static/media/ioc.7d984c2f.png";